import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MedioPagoSelect } from 'sharedComponents/select'

const MedioPagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='M. DE PAGO' htmlFor='select-MedioDePago' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='medioPago'>
          {({ field }) => <MedioPagoSelect {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-MedioDePago' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MedioPagoFormGroup)
